import React, { forwardRef } from "react";
import { useMsal } from "@azure/msal-react";
import Dropdown from "react-bootstrap/Dropdown";
import ProfilePhoto from "./ProfilePhoto";

const SignOutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const MenuToggle = forwardRef(({ onClick, children, "aria-expanded": expanded }, ref) => (
  <button
    ref={ref}
    type="button"
    className="user-menu__toggle"
    aria-expanded={expanded}
    aria-haspopup="true"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </button>
));

// Name and photo of the signed-in user, with the account details and Sign out in a menu (same as Flowchart Checker)
export default function UserMenu() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const name = account?.name || account?.username || "User";

  return (
    <Dropdown align="end">
      <Dropdown.Toggle as={MenuToggle}>
        <span className="d-none d-md-inline fw-medium small">{name}</span>
        <ProfilePhoto size={32} />
        <span className="user-menu__caret" aria-hidden="true" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="user-menu__panel py-1">
        <div className="d-flex align-items-center justify-content-between gap-2 px-3 py-2 border-bottom">
          <div className="text-truncate text-start">
            <div className="fw-medium small text-truncate">{name}</div>
            {account?.username && <div className="small text-body-secondary text-truncate">{account.username}</div>}
          </div>
          <ProfilePhoto size={40} />
        </div>
        <Dropdown.Item as="button" className="d-flex align-items-center gap-2 small py-2" onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: "/" })}>
          <SignOutIcon />
          Sign out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
